import type { CheckoutDay } from "./stayCheckoutModel";

export interface StayCheckoutTextLabels {
  header: string;
  activities: string;
  observations: string;
  deliveredItems: string;
  photos: string;
  done: string;
  pending: string;
  comanda: string;
}

export interface BuildStayCheckoutTextArgs {
  petName: string;
  moduleLabel: string;
  periodLabel: string;
  days: CheckoutDay[];
  deliveredItems: string[];
  comandaLines: string[];
  galleryUrl: string | null;
  labels: StayCheckoutTextLabels;
  formatDay: (iso: string) => string;
}

const section = (title: string, lines: string[]): string[] =>
  lines.length === 0 ? [] : ["", `*${title}*`, ...lines];

/**
 * O relato que vai para o WhatsApp do responsável no checkout. Seção sem
 * conteúdo é omitida inteira — mandar "Observações" vazio só gera pergunta.
 */
export function buildStayCheckoutText(args: BuildStayCheckoutTextArgs): string {
  const activityLines = args.days.flatMap((day) =>
    day.activities.map((activity) => {
      const time = activity.time ? `${activity.time} ` : "";
      const description = activity.description ? ` — ${activity.description}` : "";
      const status = activity.done ? args.labels.done : args.labels.pending;
      return `${args.formatDay(day.day)}: ${time}${activity.typeName}${description} (${status})`;
    }),
  );

  const observationLines = args.days.flatMap((day) =>
    day.observations.map((observation) => {
      const time = observation.time ? `${observation.time} ` : "";
      return `${args.formatDay(day.day)}: ${time}${observation.typeName} — ${observation.description}`;
    }),
  );

  return [
    `*${args.labels.header}*`,
    `${args.petName} · ${args.moduleLabel} · ${args.periodLabel}`,
    ...section(args.labels.activities, activityLines),
    ...section(args.labels.observations, observationLines),
    ...section(args.labels.deliveredItems, args.deliveredItems.map((item) => `• ${item}`)),
    ...section(args.labels.comanda, args.comandaLines),
    ...section(args.labels.photos, args.galleryUrl ? [args.galleryUrl] : []),
  ].join("\n");
}
